import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIService } from './ui.service';

@Injectable({ providedIn: 'root' })
export class PrivateLayoutService {
  private translateService = inject(TranslateService);
  private uiService = inject(UIService);

  stateSidebar = signal<boolean>(false);

  constructor() {
    this.translateService.onLangChange.subscribe(() => {
      this.uiService.freeze();

      this.uiService.unFreeze();
    });
  }

  toggleSidebar(): void {
    this.stateSidebar.set(!this.stateSidebar());
  }
}
